<template>
  <div style="background:#fff;">
    <div class="page_title"
         v-if="art_id">编辑患教文章</div>
    <div class="page_title"
         v-else>添加患教文章</div>
    <div class="container">
      <div class="essay">
        <div style="margin-bottom:20px">
          <el-input v-model="title"
                    placeholder="请输入标题"
                    maxlength="30"
                    show-word-limit></el-input>
        </div>
        <div style="margin-bottom:20px">
          <el-input v-model="author"
                    placeholder="作者"
                    maxlength="11"
                    show-word-limit></el-input>
        </div>
        <div style="margin-bottom:20px">
          <el-input v-model="summary"
                    placeholder="摘要"
                    type="textarea"
                    maxlength="100"
                    show-word-limit></el-input>
        </div>
        <div style="margin-bottom:20px"
             class="input-number">
          <el-input-number v-model="read_num"
                           size="small"
                           :min="0"
                           :precision="0"
                           :max="9999999999"
                           :controls="false"
                           placeholder="虚拟阅读量"></el-input-number>
        </div>
        <div style="width:100%;height:100%;">
          <wangeditorNew ref="editorBox"
                         @changeCheck="changeCheck"
                         :margins="margins" />
        </div>
        <div class="btnbox">
          <div>
            <el-button type="primary"
                       round
                       style="width:100px;margin-right:5px"
                       @click="submit">保存</el-button>
            <el-button plain
                       round
                       style="width:100px"
                       @click="back">退出</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import wangeditorNew from '../wangeditorNew.vue';

export default {
  data() {
    return {
      title: '',
      summary: '',
      author: '歧黄医官 | 编辑整理',
      art_id: this.$route.query.art_id,
      margins: 1,
      read_num: undefined
    };
  },
  components: {
    wangeditorNew
  },
  methods: {
    //发布
    submit() {
      if (!this.title) {
        this.$message.error('请填写标题');
        return false;
      }
      if (!this.summary) {
        this.$message.error('请填写摘要');
        return false;
      }
      let content = this.$refs.editorBox.editor.getHtml();
      if (!content) {
        this.$message.error('请填写内容');
        return false;
      }

      let data = {
        title: this.title,
        content: content,
        summary: this.summary,
        author: this.author,
        margins: this.margins,
        read_num: this.read_num,
        art_id: this.art_id || 0
      };

      this.axios
        .post('platform/library/saveArticlesOnPatientEducationInfo', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('保存成功');
            this.back();
          }
        });
    },
    //获取图文信息
    getDetail() {
      if (!this.art_id) return;
      let data = {
        art_id: this.art_id
      };
      this.axios
        .post('platform/library/getArticlesOnPatientEducationInfo', data)
        .then((res) => {
          if (res.code == 0) {
            let detail = res.data.info;
            this.title = detail.title;
            this.summary = detail.summary;
            this.margins = detail.margins;
            this.read_num = detail.read_num;
            this.setDesc(detail.content);
            if (detail.author) {
              this.author = detail.author;
            }
          }
        });
    },
    //获取边距
    changeCheck(value) {
      this.margins = value;
    },
    //往编辑器里插入数据
    setDesc(text) {
      this.$refs.editorBox.editor.setHtml(text);
    },
    back() {
      history.back();
    }
  },
  created() {
    this.margins = 1;
    this.getDetail();
  }
};
</script>
<style lang="scss" scoped>
.container {
  min-height: calc(100vh - 120px);
  background: #fff;
  padding-bottom: 20px;
}
.essay {
  width: 70%;
  margin: 20px auto 0;
  // padding-bottom: 20px;
}
.btnbox {
  width: 100%;
  height: 58px;
  border: solid 1px #cfcece;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 30px;
  box-sizing: border-box;
  background: #fff;
  margin-top: 20px;
}
.input-number {
  .el-input-number {
    width: 100%;
    ::v-deep input {
      text-align: left !important;
    }
  }
}
</style>
